import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { withValidation } from '@glu/validation-react';
import { Button } from '@glu/buttons-react';
import classnames from 'classnames';
import uniqId from '../../utils/uniqId';

export class ButtonComponent extends PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    className: PropTypes.string,
    disabled: PropTypes.bool,
    errors: PropTypes.objectOf(PropTypes.array),
    events: PropTypes.bool,
    registerValidators: PropTypes.func.isRequired,
    unregisterValidators: PropTypes.func,
    registerSelfValidatingChild: PropTypes.func,
    unregisterSelfValidatingChild: PropTypes.func,
    validate: PropTypes.func
  };

  static defaultProps = {
    children: [],
    className: '',
    disabled: false,
    errors: {},
    events: false,
    unregisterValidators: null,
    registerSelfValidatingChild: null,
    unregisterSelfValidatingChild: null,
    validate: null
  };

  state = { id: uniqId('button-') };

  render() {
    const {
      children,
      className,
      disabled: disabledProp,
      errors,
      events,
      // Remove to prevent errors
      registerSelfValidatingChild,
      registerValidators,
      unregisterSelfValidatingChild,
      unregisterValidators,
      validate,
      resetData,
      resetErrors,
      ...props
    } = this.props;

    const hasError = Object.values(errors)
      .map((item) => item && item.length > 0)
      .find(Boolean);
    const disabled = disabledProp || hasError;

    if (events) {
      return (
        <Button {...props} className={classnames(className, { disabled })}>
          {children}
        </Button>
      );
    }

    return (
      <Button disabled={disabled} className={className} {...props}>
        {children}
      </Button>
    );
  }
}

export default withValidation(ButtonComponent);
